var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoader = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.67 15.5065C28.79 15.5065 27.99 14.9265 27.74 14.0365C26.34 8.9965 21.72 5.4865 16.5 5.4865C11.28 5.4865 6.66 9.0065 5.26 14.0365C4.96 15.0965 3.86 15.7265 2.8 15.4265C1.74 15.1265 1.11 14.0265 1.41 12.9665C3.28 6.2065 9.49 1.4865 16.5 1.4865C23.51 1.4865 29.72 6.2065 31.6 12.9665C31.9 14.0265 31.27 15.1365 30.21 15.4265C30.03 15.4765 29.85 15.4965 29.67 15.4965V15.5065ZM31.6 21.3665C31.9 20.3065 31.27 19.1965 30.21 18.9065C29.15 18.6165 28.04 19.2365 27.75 20.2965C26.35 25.3365 21.73 28.8465 16.51 28.8465C11.29 28.8465 6.67 25.3265 5.27 20.2965C4.97 19.2365 3.88 18.6065 2.81 18.9065C1.75 19.2065 1.12 20.3065 1.42 21.3665C3.3 28.1265 9.51 32.8465 16.52 32.8465C23.53 32.8465 29.74 28.1265 31.62 21.3665H31.6Z",
    fill: "#FAC300"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loader.0bad897a18faf2064bc645625a43e014.svg";